import React from 'react';

const ManufacturerList = ({
  manufacturers,
  filters,
  onFilterChange,
  onEdit,
  onDelete,
  readOnly = false
}) => (
  <table>
    <thead>
      <tr>
        <th>
          Name
          <br />
          <input
            type="text"
            value={filters.manufacturer_name}
            onChange={e => onFilterChange('manufacturer_name', e.target.value)}
            placeholder="Filter"
          />
        </th>
        <th>
          Address
          <br />
          <input
            type="text"
            value={filters.manufacturer_address}
            onChange={e => onFilterChange('manufacturer_address', e.target.value)}
            placeholder="Filter"
          />
        </th>
        <th>
          Contact Info
          <br />
          <input
            type="text"
            value={filters.manufacturer_contact_info}
            onChange={e => onFilterChange('manufacturer_contact_info', e.target.value)}
            placeholder="Filter"
          />
        </th>
        <th>{readOnly ? 'View' : 'Actions'}</th>
      </tr>
    </thead>
    <tbody>
      {manufacturers.map(manufacturer => (
        <tr key={manufacturer.manufacturer_id}>
          <td>{manufacturer.manufacturer_name}</td>
          <td>{manufacturer.manufacturer_address}</td>
          <td>{manufacturer.manufacturer_contact_info}</td>
          <td>
            {!readOnly && onEdit && (
              <button onClick={() => onEdit(manufacturer)}>Edit</button>
            )}
            {!readOnly && onDelete && (
              <button 
                onClick={() => onDelete(manufacturer.manufacturer_id)}
                style={{ 
                  marginLeft: onEdit ? 8 : 0, 
                  backgroundColor: '#dc3545', 
                  color: 'white', 
                  border: 'none', 
                  borderRadius: '4px', 
                  padding: '0.25rem 0.5rem', 
                  cursor: 'pointer',
                  transition: 'background-color 0.2s ease'
                }}
                onMouseEnter={(e) => e.target.style.backgroundColor = '#c82333'}
                onMouseLeave={(e) => e.target.style.backgroundColor = '#dc3545'}
              >
                Delete
              </button>
            )}
            {readOnly && (
              <span style={{ color: '#666', fontStyle: 'italic' }}>View Only</span>
            )}
          </td>
        </tr>
      ))}
    </tbody>
  </table>
);

export default ManufacturerList;